import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'app/shared/shared.module';
import { MetaFieldSelectorComponent } from './meta-field-selector.component';



@NgModule({
  declarations: [
    MetaFieldSelectorComponent
  ],
  imports: [
    CommonModule,
    SharedModule
  ],
  exports: [
    MetaFieldSelectorComponent
  ]
})
export class MetaFieldSelectorModule { }
